/* Build an article-specific sidebar from the public ranking list. No API or tracking. */
(() => {
  'use strict';
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ranking-sidebar-host]').forEach(host => {
      if (host.dataset.rankingIndexReady === 'true') return;
      const section = host.closest('[data-ranking-section]');
      const root = section?.querySelector('.hp-ranking[data-ranking-article]');
      const source = root?.querySelector('#ranking-index .toc');
      const nav = host.querySelector('[data-ranking-index]');
      const list = nav?.querySelector('[data-ranking-index-list]');
      if (!source || !list) return;

      const rows = [...source.querySelectorAll(':scope > li > a')];
      const entries = root.querySelectorAll('.entries > article.entry[data-work-id]');
      if (!rows.length || rows.length !== entries.length) return;
      const seen = new Set();
      const items = rows.map(row => {
        const href = row.getAttribute('href') || '';
        const title = row.querySelector('.toc-title')?.textContent.trim();
        const rank = row.querySelector('.toc-num')?.textContent.trim();
        const target = /^#[a-zA-Z0-9_-]+$/.test(href) ? document.getElementById(href.slice(1)) : null;
        if (!title || !/^\d+$/.test(rank || '') || !target || !root.contains(target)
            || !target.matches('.entries > article.entry[data-work-id]') || seen.has(target)) return null;
        seen.add(target);
        return { href, title, rank, target };
      });
      // An incomplete list must not replace the existing sidebar with misleading links.
      if (items.some(item => !item)) return;

      const fragment = document.createDocumentFragment();
      items.forEach(({ href, title, rank }) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        const number = document.createElement('span');
        const name = document.createElement('span');
        number.className = 'hp-ranking-index__number';
        number.textContent = rank;
        name.textContent = title;
        link.setAttribute('href', href);
        link.append(number, name);
        li.append(link);
        fragment.append(li);
      });
      list.replaceChildren(fragment);
      nav.hidden = false;
      host.dataset.rankingIndexReady = 'true';

      // Native fragment navigation: preserve IDs and the existing spoiler state.
      // Do not put synopsis text, hidden ending headings, or purchase URLs in the index.
      const updateOffset = () => {
        const header = document.getElementById('l-header');
        let offset = 24;
        if (header) {
          const rect = header.getBoundingClientRect();
          const position = getComputedStyle(header).position;
          if (['fixed', 'sticky'].includes(position) && rect.top <= 1 && rect.bottom > 0) {
            offset = Math.min(rect.bottom + 20, window.innerHeight / 2);
          }
        }
        host.style.setProperty('--hp-ranking-index-top', `${offset}px`);
        root.style.setProperty('--hp-ranking-index-top', `${offset}px`);
      };
      updateOffset();
      let frame;
      const refreshOffset = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateOffset);
      };
      window.addEventListener('resize', refreshOffset, { passive: true });
      window.addEventListener('scroll', refreshOffset, { passive: true });
      // Only the header needs observing; no observer or polling over the article body.
      const header = document.getElementById('l-header');
      const observer = header && window.ResizeObserver ? new ResizeObserver(refreshOffset) : null;
      observer?.observe(header);
      const themeSection = host.closest('[id^="shopify-section-"]') || section;
      themeSection.addEventListener('shopify:section:unload', () => {
        window.removeEventListener('resize', refreshOffset);
        window.removeEventListener('scroll', refreshOffset);
        cancelAnimationFrame(frame);
        observer?.disconnect();
      }, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
